import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { NgxIntlTelInputComponent } from 'ngx-intl-tel-input';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { UnlServiceService } from 'src/app/services/unl-service.service';

@Component({
  selector: 'app-login-signup',
  templateUrl: './login-signup.component.html',
  styleUrls: ['./login-signup.component.scss']
})
export class LoginSignupComponent implements OnInit {
  signupForm: FormGroup;
  loginForm: FormGroup;
  sucssesMsg = false;
  @Input() showSignupForm = true;
  @Output() closeModalEmitter = new EventEmitter<any>();
  @Input() isPopUp = false;
  private phoneNumberUtil = PhoneNumberUtil.getInstance();


  @ViewChild(NgxIntlTelInputComponent) phoneInput: NgxIntlTelInputComponent;
  logingSignup: boolean;

  constructor(private fb: FormBuilder, private unlServiceService: UnlServiceService, private http: HttpClient, private readonly authService: AuthService, private router: Router) {
    this.initForms();
    this.showSignupForm = this.router.routerState.snapshot.url !== '/login';
  }

  ngOnInit(): void {
  }

  private initForms() {
    this.signupForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      firstName: ['', [Validators.required, Validators.pattern(/^[a-zA-Z]+$/)]],
      lastName: ['', [Validators.required, Validators.pattern(/^[a-zA-Z]+$/)]],
      gender: [''],
      dob: ['', [Validators.required, this.ageValidator]],
      phone: ['', [Validators.required, this.phoneNumberValidator.bind(this)]]
    });

    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  private ageValidator(control: any) {
    const dob = new Date(control.value);
    let age = new Date().getFullYear() - dob.getFullYear();
    const month = new Date().getMonth() - dob.getMonth();
    if (month < 0 || (month === 0 && new Date().getDate() < dob.getDate())) {
      age--;
    }
    return age >= 21 ? null : { ageInvalid: true };
  }

  private phoneNumberValidator(control: any) {
    if (!control.value) return null;
    const selectedCountryCode = this.phoneInput.selectedCountryISO.toUpperCase();
    try {
      const phoneNumber = this.phoneNumberUtil.parseAndKeepRawInput(control.value, selectedCountryCode);
      return this.phoneNumberUtil.isValidNumber(phoneNumber) ? null : { pattern: true };
    } catch {
      return null;
    }
  }

  onSignup() {

    this.markFormGroupTouched(this.signupForm);

    Object.keys(this.signupForm.controls).forEach(key => {
      const control = this.signupForm.get(key);
    });

    if (this.signupForm.invalid) {
      console.log('Signup form is invalid');
      return;
    }
    const data = this.signupForm.value;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const month = data.dob ? (data.dob.getMonth() + 1).toString() : '';
    const day = data.dob ? (data.dob.getDate()).toString() : '';
    const year = data.dob ? (data.dob.getFullYear()).toString() : '';
    const name = data.firstName + data.lastName;
    console.log(typeof (data.gender));
    const gender = (data.gender == 'male') ? 'Male' : (data.gender == 'female') ? 'Female' : '';
    const cc = data.phone.countryCode + '-' + data.phone.dialCode;

    this.logingSignup = true;

    const form = new FormData();
    form.append('mail', data.email);
    form.append('profile_name', data.firstName);
    form.append('profile_lname', data.lastName);
    form.append('name', name);
    form.append('profile_gender', gender);
    form.append('profile_mobile', data.phone.internationalNumber);
    form.append('profile_dob[month]', month);
    form.append('profile_dob[day]', day);
    form.append('profile_dob[year]', year);
    form.append('profile_cc', cc);


    this.http.post(`${this.unlServiceService.basepath}testunl/user/register.json`, form, {}).subscribe(
      response => {
        this.sucssesMsg = true;
        console.log('Signup successful:', response);
        this.logingSignup = false;
      },
      error => {
        console.error('Signup error:', error);
        this.logingSignup = false;
      }
    );

  }


  onLogin() {
    if (this.loginForm.invalid) return;
    const m = this.loginForm.value;
    const userDetails = {
      "username": m.email,
      "password": m.password
    }

    this.http.post(`${this.unlServiceService.basepath}testunl/user/login.json`, userDetails).subscribe(
      response => {
        console.log('Login successful:', response)
        this.authService.setSessionData(response);
        this.router.navigate(['/all/all']);
      },
      error => console.error('Login error:', error)
    );
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control.markAsTouched({ onlySelf: true });
      }
    });
  }

  showSignup() {
    if (!this.isPopUp) {
      this.router.navigate(['/register'])
    }
    this.showSignupForm = true;
  }

  showLogin() {
    if (!this.isPopUp) {
      this.router.navigate(['/login'])
    }
    this.showSignupForm = false;
  }

  closeModal() {
    this.closeModalEmitter.emit('')
  }

}
